import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES, CHAPTERS } from "@/data";
import { Reveal } from "@/components/Reveal";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="story" data-testid="story-section" className="bg-cream py-24 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-terracotta mb-8">
            (Our story)
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-24 items-start">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-charcoal">
                A quiet place, kept
                <span className="italic text-mist"> honest.</span>
              </h2>
            </Reveal>
            <div ref={ref} className="mt-10 overflow-hidden rounded-md">
              <motion.img
                style={{ y: imgY, scale: 1.12 }}
                src={IMAGES.mist}
                alt="Mist rolling over the lawn and forested hills at Vistara"
                className="w-full h-[320px] md:h-[440px] object-cover will-change-transform"
              />
            </div>
          </div>

          <div className="flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="py-8 md:py-10 border-t border-charcoal/12 first:border-t-0 grid grid-cols-[auto_1fr] gap-6 md:gap-10">
                  <span className="font-serif text-3xl md:text-4xl text-terracotta/70">{c.no}</span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-charcoal mb-3">{c.title}</h3>
                    <p className="font-sans text-base md:text-lg leading-relaxed text-charcoal/70 max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
